/* unplugin-vue-components disabled */import { render } from "./CDateSelect1.vue?vue&type=template&id=dfafe5e8&scoped=true&ts=true"
import script from "./CDateSelect1.vue?vue&type=script&lang=ts"
export * from "./CDateSelect1.vue?vue&type=script&lang=ts"

import "./CDateSelect1.vue?vue&type=style&index=0&id=dfafe5e8&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfafe5e8"]])

export default __exports__